/**
 * Region Configuration System (Frontend)
 *
 * Controls all region-specific behavior in the frontend.
 * Set REACT_APP_REGION environment variable to 'br' or 'lb'.
 * Defaults to 'br' for backward compatibility.
 */

const REGION = process.env.REACT_APP_REGION || 'br';

const regionConfigs = {
  br: {
    region: 'br',

    brand: {
      name: 'Pede Ja',
      logoPath: 'logoBlue.png',
      domain: 'pedeja.chat',
      appDomain: 'app.pedeja.chat',
      garcomDomain: 'garcom.pedeja.chat',
      supportUrl: 'https://pedeja.chat',
      botName: 'PedeJa Bot',
      printGithubRepo: 'PedeJaSoftware/PedeJaPrint-Release',
      printSetupFile: 'PedeJaPrintSetup.exe',
    },

    locale: {
      default: 'pt-BR',
      fallback: 'pt-BR',
      timezone: 'America/Sao_Paulo',
      dateFormat: 'DD/MM/YYYY',
      dateTimeFormat: 'DD/MM/YYYY HH:mm',
    },

    currency: {
      code: 'BRL',
      symbol: 'R$',
      locale: 'pt-BR',
      decimalSeparator: ',',
      thousandSeparator: '.',
    },

    address: {
      provider: 'viacep',
      postalCodeName: 'CEP',
      postalCodeMask: '99999-999',
      subdivisionLabel: 'Estado',
      cityLabel: 'Municipio',
      neighborhoodLabel: 'Bairro',
    },

    map: {
      defaultLat: -15.7942,
      defaultLng: -47.8822,
      language: 'pt',
      googleRegion: 'BR',
    },

    identity: {
      documentTypes: ['cpf', 'cnpj'],
      documentLabel: 'CPF/CNPJ',
      phonePrefix: '+55',
      phoneMask: '(99) 99999-9999',
      // País ISO default do seletor de telefone e países fixados no topo do picker.
      defaultCountry: 'BR',
      preferredCountries: ['BR'],
    },

    payment: {
      methods: {
        cash: true,
        card: true,
        pix: true,
      },
    },

    facebookPixelId: '1370937417602398',

    features: {
      pix: true,
      cpfCnpj: true,
      cepLookup: true,
      tunaPayments: true,
      asaas: true,
      facebookPixel: true,
      ibge: true,
      menuImport: true,
      // Multi-moeda por empresa: o Brasil opera só em BRL, então a aba de
      // configuração de moeda nem aparece. A camada de currency.js funciona
      // igual nas duas regiões — esta flag controla apenas a UI.
      multiCurrency: false,
    },
  },

  lb: {
    region: 'lb',

    brand: {
      name: 'Easy Order',
      logoPath: 'logoEasyOrder.png',
      domain: 'easyorder.io',
      appDomain: 'app.easyorder.io',
      garcomDomain: 'waiter.easyorder.delivery',
      supportUrl: 'https://easyorder.io',
      botName: 'Easy Order Bot',
      printGithubRepo: 'PedeJaSoftware/EasyOrderPrint-Release',
      printSetupFile: 'EasyOrderPrintSetup.exe',
    },

    locale: {
      default: 'en-US',
      fallback: 'en-US',
      timezone: 'Asia/Beirut',
      dateFormat: 'MM/DD/YYYY',
      dateTimeFormat: 'MM/DD/YYYY HH:mm',
    },

    currency: {
      code: 'USD',
      symbol: '$',
      locale: 'en-US',
      decimalSeparator: '.',
      thousandSeparator: ',',
    },

    address: {
      provider: 'manual',
      postalCodeName: 'Postal Code',
      postalCodeMask: '99999999',
      subdivisionLabel: 'Governorate',
      cityLabel: 'City',
      neighborhoodLabel: 'Area',
    },

    map: {
      defaultLat: 33.8938,
      defaultLng: 35.5018,
      language: 'en',
      googleRegion: 'LB',
    },

    identity: {
      documentTypes: [],
      documentLabel: null,
      phonePrefix: '+961',
      phoneMask: '99 999999',
      // Líbano default + vizinhos/comuns fixados no topo do picker (Líbano é pequeno
      // e muitos clientes usam DDIs da região). Configurável.
      defaultCountry: 'LB',
      preferredCountries: ['LB', 'SY', 'CY', 'JO', 'AE', 'SA', 'FR'],
    },

    payment: {
      methods: {
        cash: true,
        card: true,
        pix: false,
      },
    },

    facebookPixelId: '2135061503896863',

    features: {
      pix: false,
      cpfCnpj: false,
      cepLookup: false,
      tunaPayments: false,
      asaas: false,
      facebookPixel: true,
      ibge: false,
      menuImport: false,
      // Líbano: lojas operam em USD e/ou LBP, cada uma com sua cotação.
      multiCurrency: true,
    },
  },
};

const regionConfig = regionConfigs[REGION];

if (!regionConfig) {
  console.error(`[REGION-CONFIG] Unknown REGION: "${REGION}". Falling back to 'br'.`);
}

export { REGION, regionConfigs };
export default regionConfig || regionConfigs.br;
